import { useEffect, useRef } from 'react';
import { backButton, mainButton } from '@telegram-apps/sdk-react';

import {
  popBackHandler,
  pushBackHandler,
  triggerBack
} from '@/hooks/manager/backButtonManager.ts';

export const useBackButtonToCloseModal = (
  handleModalClose?: () => void,
  hideBackButton: boolean = true
) => {
  const scrollContainerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    scrollContainerRef.current =
      document.querySelector('#root') || document.body;
  }, []);

  useEffect(() => {
    const handler = () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.style.overflowY = 'hidden';
      }

      handleModalClose?.();

      if (hideBackButton && backButton.isVisible()) {
        backButton.hide();
      }

      mainButton.setParams({ isVisible: false });

      setTimeout(() => {
        if (scrollContainerRef.current) {
          scrollContainerRef.current.style.overflowY = '';
        }
      }, 50);
    };

    pushBackHandler(handler);

    if (!backButton.isVisible()) {
      backButton.show();
    }

    backButton.onClick(triggerBack);

    return () => {
      popBackHandler(handler);
    };
  }, []);

  return { backButtonInstance: backButton };
};
